import {useRouteError} from 'react-router'

export const RouterRootErrorBoundary = () => {
  const error = useRouteError()
  throw error // Bubble up errors to Global error boundary, if needed handle error here or in child route error boundary
}
